import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=74eeb9fc"
import script from "./PreviewTable.vue?vue&type=script&lang=js"
export * from "./PreviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports